import queryString from "query-string";
import fr from "./fr/app.json";
import de from "./de/app.json";

export interface I18nRecord {
    [key: string]: string | I18nRecord;
}

export const DEFAULT_LANG = "fr";
export const DEFAULT_LOCALE = "fr-CH";

export const AVAILABLE_LANGUAGE = ["fr", "de"];

export const STATIC_TRANSLATIONS: Record<string, I18nRecord> = {
    fr: { ...fr },
    de: { ...de },
};

/**
 * Extracts the language carried by a `?lang=` query param, when it is one we actually
 * support. Links are generated outside the app (verification emails, notifications), so the
 * value is untrusted: a repeated param yields an array, and the case is not guaranteed.
 */
export const getLangFromUrl = (href: string) => {
    const { lang } = queryString.parseUrl(href).query;
    const normalized = typeof lang === "string" ? lang.toLowerCase() : undefined;

    return normalized && AVAILABLE_LANGUAGE.includes(normalized) ? normalized : undefined;
};
